import React from 'react';

export const OidcRoutesContext = React.createContext();
